import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { Box, Flex, Text, Button, Pagination, Modal } from '@mantine/core' 
import { IconPlus } from '@tabler/icons-react'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getFaqList, deleteFaq } from '../../../../services/faq'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableFaq from '../../../../component/pages/FAQ/TableFaq'
import FormAdjustFaq from '../../../../component/pages/FAQ/FormAdjustFaq'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-created_at',
  include: 'creator,updater',
}

const labelTable = [
  {
    label: 'Question',
    width: 500
  },
  {
    label: 'Answer',
    width: 500
  },
  {
    label: 'Keyword',
    width: 300
  },
  {
    label: 'Action',
    width: 50
  },
]

const Faq = () => {
  const dispatch = useDispatch()
  const [params, setParams] = useState(defaultParameter)
  const [faqList, setFaqList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(true)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Promotions',
      route: null
    },
    {
      label: 'FAQ',
      route: null
    },
  ]

  const handleGetFaqList = async () => {
    setLoading(true)
    try {
      const response = await getFaqList(params)
      if (response.success) {
        const dataFaq = response.data
        const countData = response.meta.pagination.total || 0

        const remapData = dataFaq.map((val) => {
          return val.attributes
        })

        setFaqList(remapData)
        setTotalData(countData)
      } else {
        setFaqList([])
        setTotalData(0)
      }
    } catch (error) {
      console.error('Failed to fetch FAQ list:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetFaqList()
    // eslint-disable-next-line
  }, [params])

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    delete: (val) => {
      modalDeleteData('FAQ', val.id, val.question, deleteFaq, handleGetFaqList)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>FAQ</Text>
            <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add FAQ</Button>
          </Flex>
        </Box>
        <Box my={30}>
          {loading ? <LoadingData /> : faqList.length > 0 ? <TableFaq label={labelTable} data={faqList} actionMethod={handleAction} /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} value={params['page[num]']} total={totalData > 0 ? Math.ceil(totalData / params['page[limit]']) : totalData} />
        </Flex>
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>{detailData !== null ? 'Edit' : 'Add'} FAQ</Text>} withCloseButton={false}>
        <FormAdjustFaq dataFaq={detailData} onCloseForm={onCloseModalForm} reloadList={handleGetFaqList} />
      </Modal>
    </AuthLayout>
  )
}

export default Faq